import { forwardRef } from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import CastIcon from '@mui/icons-material/CastTwoTone';
import { getDomain } from '@/Infrastructure/Utilities/domain';
import { NavItemProps } from '../types';
import { AvatarMenuItemProps } from './types';

import styles from '../NavigationBarItem.module.css';

function getRemoteAssistanceHref() {
  return `http://connect.${getDomain()}`;
}

export default function RemoteAssistanceListItem({ isDesktopOpen, isMobile }: NavItemProps) {
  const href = getRemoteAssistanceHref();

  return (
    <ListItem
      disablePadding
      className={styles['navigation-item']}
      title='Remote Assistance'>
      <ListItemButton
        component='a'
        href={href}
        target='_blank'
        rel='noopener noreferrer'
        className={styles['navigation-item-btn']}>
        <ListItemIcon className={styles['navigation-item-btn-icon']}>
          <CastIcon />
        </ListItemIcon>
        <ListItemText
          primary='Remote Assistance'
          slotProps={{
            primary: {
              className: `${styles['navigation-item-btn-text']} ${!isDesktopOpen && !isMobile ? styles.hidden : ''}`,
              variant: 'body1'
            }
          }}
        />
      </ListItemButton>
    </ListItem>
  );
}

export const RemoteAssistanceMenuItem = forwardRef<HTMLAnchorElement, AvatarMenuItemProps<HTMLAnchorElement>>(
  function RemoteAssistanceMenuItem({ textClassName, ...props }, ref) {
    return (
      <MenuItem
        ref={ref}
        component='a'
        href={getRemoteAssistanceHref()}
        target='_blank'
        rel='noopener noreferrer'
        {...props}>
        <ListItemIcon>
          <CastIcon />
        </ListItemIcon>
        <ListItemText slotProps={{ primary: { className: textClassName } }}>Remote Assistance</ListItemText>
      </MenuItem>
    );
  }
);
